import React from "react";

import { Box } from "@mui/material";

import HubSpotCRM from "components/organisms/CRMs/HubSpotCRM";

const HubSpotSourceForm = ({ hubspot, registerFooterAction }) => (
    <Box>
        <HubSpotCRM
            isModal
            useHostFooter
            registerFooterAction={registerFooterAction}
            isCrmView={hubspot.isConnected}
            sourceId={hubspot.sourceId}
            isAuthLoading={hubspot.isAuthLoading}
            setIsAuthLoading={hubspot.setIsAuthLoading}
            isLoginButtonDisabled={!hubspot.isLoginEnabled}
            name={hubspot.name}
            onNameChange={hubspot.handleNameChange}
            onLoginSuccess={hubspot.handleLoginSuccess}
            onMappingSuccess={hubspot.handleMappingSuccess}
            selectedHubspotModule={hubspot.selectedModule}
            setSelectedHubspotModule={hubspot.setSelectedModule}
        />
    </Box>
);

export default HubSpotSourceForm;
